import React from 'react'
import { View, ViewProps, ViewStyle } from 'react-native'
import { useStyles } from 'lib/styles'

interface GapProps extends ViewProps {
    gapTop?: number,
    gapBottom?: number,
    gapLeft?: number,
    gapRight?: number,
    style?: ViewStyle
}

export const Gap: React.FunctionComponent<GapProps> = ({
    gapTop,
    gapBottom,
    gapLeft,
    gapRight,
    style,
    children,
    ...props
}) => {
    const { theme } = useStyles()

    return (
        <View
            {...props}
            style={{
                marginTop: gapTop ? theme.utils.gap(gapTop) : undefined,
                marginBottom: gapBottom ? theme.utils.gap(gapBottom) : undefined,
                marginLeft: gapLeft ? theme.utils.gap(gapLeft) : undefined,
                marginRight: gapRight ? theme.utils.gap(gapRight) : undefined,
                ...style
            }}
            children={children}
        />
    )
}
